import React from "react";
import PropTypes from "prop-types";


/**
 * Renders the location field in the metadata column. This is a child of <MetaCell>
 */
export default function Location(props) {
  if (props.label && props.description) {
    return (
      <div className="location-description">
        {props.label} (<em>{props.description}</em>)
      </div>
    );
  } else if (props.description) {
    return (
      <div className="location-description">
        <em>{props.description}</em>
      </div>
    );
  }
  return <div className="location-description">{props.label}</div>;
}

Location.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string
};
